import { render, staticRenderFns } from "./listesPatiens.vue?vue&type=template&id=923f8780&scoped=true&"
import script from "./listesPatiens.vue?vue&type=script&lang=js&"
export * from "./listesPatiens.vue?vue&type=script&lang=js&"
import style0 from "./listesPatiens.vue?vue&type=style&index=0&id=923f8780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923f8780",
  null
  
)

export default component.exports